import React, { useState, useEffect } from 'react';
import { formatTimeInTimeZone } from '../../utils/timezone';

interface CurrentTimeLineProps {
  className?: string;
}

const CurrentTimeline: React.FC<CurrentTimeLineProps> = ({ className = '' }) => {
  // État pour suivre l'heure actuelle
  const [currentTime, setCurrentTime] = useState(new Date());
  
  // Mettre à jour l'heure actuelle toutes les minutes
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // 60000 ms = 1 minute
    
    return () => clearInterval(interval);
  }, []);
  
  // Calculer la position de la ligne d'heure actuelle
  const getCurrentTimePosition = () => {
    const now = currentTime;
    const hours = parseInt(formatTimeInTimeZone(now, 'HH'));
    const minutes = parseInt(formatTimeInTimeZone(now, 'mm'));
    
    // Calculer le pourcentage de la journée écoulée (pour le positionnement vertical)
    return (hours * 60 + minutes) / (24 * 60) * 100;
  };

  return (
    <div 
      className={`absolute left-0 right-0 z-10 pointer-events-none ${className}`} 
      style={{ 
        top: `calc(${getCurrentTimePosition()}% - 1px)`,
      }}
    >
      <div className="flex items-center">
        <div className="w-3 h-3 rounded-full bg-red-500 shadow-md relative -left-1.5"></div>
        <div className="h-[2px] bg-red-500 w-full"></div>
      </div>
    </div>
  );
};

export default CurrentTimeline;
